module.exports = __webpack_public_path__ + "media/monkey.77c608e1.mp3";